// import React, { useEffect, useState } from "react";
// import "./LLM_Configuration.css";

// export const LLM_Configuration = () => {
//   const [plants, setPlants] = useState([]);
//   const [models, setModels] = useState([]);
//   const [params, setParams] = useState([]);
//   const [plant, setPlant] = useState("");
//   const [model, setModel] = useState("");
//   const [formData, setFormData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [deleting, setDeleting] = useState(false);
//   const [error, setError] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isCreateMode, setIsCreateMode] = useState(false);
//   const [selectedModelName, setSelectedModelName] = useState("");

//   // Column name mappings (frontend name -> database name)
//   const COLUMN_MAPPING = {
//     "modelname": "ModelName",
//     "modelname": "ModelName",
//     "modelparametersjson": "ModelParametersJson",
//     "modelparameters": "ModelParameters",
//     "plantguid": "PlantGUID",
//     "isactive": "IsActive",
//     // Add more mappings as needed
//   };

//   // Fetch plants
//   useEffect(() => {
//     fetch("/config/llm-plants/")
//       .then((r) => r.json())
//       .then((data) => {
//         if (data.success) {
//           setPlants(data.data || []);
//         } else {
//           setError("Failed to load plants");
//         }
//       })
//       .catch(() => setError("Failed to load plants"));
//   }, []);

//   const selectPlant = (plantId) => {
//     setPlant(plantId);
//     setModel("");
//     setSelectedModelName("");
//     setParams([]);
//     setFormData({});
//     setIsCreateMode(false);
//     setError("");
//     setSearchTerm("");

//     if (!plantId) return;

//     setLoading(true);
//     fetch(`/config/llm-models/${plantId}/`)
//       .then((r) => r.json())
//       .then((data) => {
//         if (data.success) {
//           setModels(data.data || []);
//         } else {
//           setError("Failed to load models");
//         }
//       })
//       .catch(() => setError("Failed to load models"))
//       .finally(() => setLoading(false));
//   };

//   const selectModel = (modelId) => {
//     setModel(modelId);
//     setIsCreateMode(false);
//     setError("");
//     setSearchTerm("");

//     if (!modelId) {
//       setParams([]);
//       setFormData({});
//       setSelectedModelName("");
//       return;
//     }

//     // Find the selected model name
//     const selectedModel = models.find(m => m.id === modelId);
//     setSelectedModelName(selectedModel ? selectedModel.name : "");

//     setLoading(true);
//     fetch(`/config/llm-configurations/${modelId}/`)
//       .then((r) => r.json())
//       .then((data) => {
//         if (data.success) {
//           const fields = data.data || [];
//           setParams(fields);
//           const values = {};
//           fields.forEach((f) => {
//             // Handle JSONB values that might be objects
//             const val = f.value;
//             if (f.data_type === "jsonb" && typeof val === "object" && val !== null) {
//               values[f.column_name] = JSON.stringify(val, null, 2);
//             } else {
//               values[f.column_name] = val ?? "";
//             }
//           });
//           setFormData(values);
//         } else {
//           setError("Failed to load parameters");
//         }
//       })
//       .catch(() => setError("Failed to load parameters"))
//       .finally(() => setLoading(false));
//   };

//   const startCreateMode = () => {
//     if (!plant) {
//       setError("Please select a plant first");
//       return;
//     }
    
//     setModel("");
//     setSelectedModelName("");
//     setIsCreateMode(true);
//     setError("");
//     setSearchTerm("");

//     setLoading(true);
//     fetch("/config/llm-configurations/")
//       .then((r) => r.json())
//       .then((data) => {
//         if (data.success) {
//           const fields = data.data || [];
//           setParams(fields);
//           const values = {};
//           fields.forEach((f) => {
//             values[f.column_name] = "";
//           });
//           // Set default plant if not already set
//           if (plant) {
//             values.PlantGUID = plant;
//           }
//           setFormData(values);
//         } else {
//           setError("Failed to load form");
//         }
//       })
//       .catch(() => setError("Failed to load form"))
//       .finally(() => setLoading(false));
//   };

//   const cancelCreateMode = () => {
//     setIsCreateMode(false);
//     setModel("");
//     setSelectedModelName("");
//     setParams([]);
//     setFormData({});
//     setError("");
//     setSearchTerm("");
//     // Reload models for the current plant
//     if (plant) {
//       selectPlant(plant);
//     }
//   };

//   const changeValue = (name, value) => {
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const renderControl = (field) => {
//     const value = formData[field.column_name] ?? "";
//     const name = field.column_name;

//     if (name === "isactive" || name === "IsActive") {
//       return (
//         <label className="llm-toggle-switch">
//           <input
//             type="checkbox"
//             checked={value === true || value === "true" || value === 1}
//             onChange={(e) => changeValue(name, e.target.checked)}
//           />
//           <span className="llm-slider"></span>
//         </label>
//       );
//     }
//     if (field.data_type === "jsonb") {
//       return (
//         <textarea
//           className="llm-input-field"
//           rows={4}
//           value={value}
//           onChange={(e) => {
//             const val = e.target.value;
//             // Try to parse as JSON to validate
//             try {
//               if (val.trim()) {
//                 JSON.parse(val);
//               }
//               changeValue(name, val);
//             } catch {
//               // If invalid JSON, still update but mark as invalid
//               changeValue(name, val);
//             }
//           }}
//           style={{
//             borderColor: (() => {
//               try {
//                 if (value.trim()) {
//                   JSON.parse(value);
//                 }
//                 return undefined;
//               } catch {
//                 return "#ef4444";
//               }
//             })()
//           }}
//         />
//       );
//     }
//     if (field.data_type === "integer" || field.data_type === "bigint") {
//       return (
//         <input
//           type="number"
//           className="llm-input-field"
//           value={value}
//           onChange={(e) => changeValue(name, e.target.value)}
//         />
//       );
//     }
//     if (field.data_type === "boolean") {
//       return (
//         <label className="llm-toggle-switch">
//           <input
//             type="checkbox"
//             checked={value === true || value === "true" || value === 1}
//             onChange={(e) => changeValue(name, e.target.checked)}
//           />
//           <span className="llm-slider"></span>
//         </label>
//       );
//     }
//     return (
//       <input
//         type="text"
//         className="llm-input-field"
//         value={value}
//         onChange={(e) => changeValue(name, e.target.value)}
//       />
//     );
//   };

//   const filteredParams = params.filter((field) => {
//     const label = field.column_name.replace(/_/g, " ").toLowerCase();
//     return label.includes(searchTerm.toLowerCase()) || 
//            field.column_name.toLowerCase().includes(searchTerm.toLowerCase());
//   });

//   const handleSave = () => {
//     if (!plant) {
//       setError("Please select a plant");
//       return;
//     }
    
//     // Check for required fields (using both lowercase and uppercase variants)
//     const modelNameValue = formData.modelname || formData.ModelName;
//     if (isCreateMode && !modelNameValue) {
//       setError("ModelName is required");
//       return;
//     }

//     setSaving(true);
//     setError("");

//     const url = isCreateMode 
//       ? "/config/llm-configurations/" 
//       : `/config/llm-configurations/${model}/`;
    
//     const method = isCreateMode ? "POST" : "PATCH";

//     // Prepare data for submission with proper column name mapping
//     const submitData = {};
    
//     // Map frontend column names to database column names
//     Object.keys(formData).forEach(key => {
//       let dbKey = key;
      
//       // Apply column name mapping
//       if (COLUMN_MAPPING[key]) {
//         dbKey = COLUMN_MAPPING[key];
//       } else {
//         // If no mapping, keep the original case (database might be case-sensitive)
//         // For PostgreSQL, we need to use the exact column name with quotes
//         dbKey = key;
//       }
      
//       let val = formData[key];
      
//       // Handle JSONB fields - parse string to object
//       const field = params.find(f => f.column_name === key);
//       if (field && field.data_type === "jsonb" && typeof val === "string" && val.trim()) {
//         try {
//           submitData[dbKey] = JSON.parse(val);
//         } catch {
//           // If invalid JSON, keep as string
//           submitData[dbKey] = val;
//         }
//       } else {
//         // Convert empty strings to null
//         submitData[dbKey] = val === "" ? null : val;
//       }
//     });

//     // Add PlantGUID
//     submitData.PlantGUID = plant;

//     console.log("Submitting data:", submitData); // Debug log

//     fetch(url, {
//       method,
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(submitData),
//     })
//       .then((r) => r.json())
//       .then((data) => {
//         if (data.success) {
//           alert(data.message || (isCreateMode ? "Configuration created successfully" : "Configuration updated successfully"));
//           if (isCreateMode && data.id) {
//             // Refresh the model list and select the new model
//             setPlant(plant);
//             setIsCreateMode(false);
//             setModel(data.id);
//             // Reload models for the plant
//             selectPlant(plant);
//             // After reload, select the new model
//             setTimeout(() => {
//               selectModel(data.id);
//             }, 100);
//           } else {
//             // Refresh current model data
//             selectModel(model);
//           }
//         } else {
//           setError(data.message || "Save failed");
//         }
//       })
//       .catch((error) => {
//         console.error("Save error:", error);
//         setError("Network error: " + error.message);
//       })
//       .finally(() => setSaving(false));
//   };

//   const handleDelete = () => {
//     if (!model || isCreateMode) return;
//     if (!window.confirm("Are you sure you want to delete this configuration?")) return;

//     setDeleting(true);
//     fetch(`/config/llm-configurations/${model}/`, { method: "DELETE" })
//       .then((r) => r.json())
//       .then((data) => {
//         if (data.success) {
//           alert("Configuration deleted successfully");
//           selectPlant(plant);
//         } else {
//           setError(data.message || "Delete failed");
//         }
//       })
//       .catch(() => setError("Network error"))
//       .finally(() => setDeleting(false));
//   };

//   return (
//     <div className="llm-admin-container">
//       <div className="llm-admin-header">
//         <div>
//           <h1 className="llm-admin-title">LLM Configuration</h1>
//           <p className="llm-admin-subtitle">Manage LLM model configurations per plant</p>
//         </div>
//         <button 
//           className="btn" 
//           onClick={startCreateMode}
//           disabled={!plant || isCreateMode}
//           style={{ background: "#10b981" }}
//         >
//           + New Model
//         </button>
//       </div>

//       <div className="llm-config-card" style={{ padding: "24px" }}>
//         {!isCreateMode ? (
//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", alignItems: "end" }}>
//             <div>
//               <label style={{ fontWeight: 600, display: "block", marginBottom: "6px" }}>Select Plant</label>
//               <select 
//                 className="llm-select-field" 
//                 value={plant} 
//                 onChange={(e) => selectPlant(e.target.value)}
//               >
//                 <option value="">Select Plant</option>
//                 {plants.map((p) => (
//                   <option key={p.id} value={p.id}>{p.name}</option>
//                 ))}
//               </select>
//             </div>

//             <div>
//               <label style={{ fontWeight: 600, display: "block", marginBottom: "6px" }}>Select Model</label>
//               <select 
//                 className="llm-select-field" 
//                 value={model} 
//                 onChange={(e) => selectModel(e.target.value)}
//                 disabled={!plant}
//               >
//                 <option value="">Select Model</option>
//                 {models.map((m) => (
//                   <option key={m.id} value={m.id}>{m.name}</option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         ) : (
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//             <div>
//               <h3 style={{ margin: 0, color: "#1f2937" }}>Create New Model Configuration</h3>
//               <p style={{ margin: "4px 0 0 0", color: "#6b7280", fontSize: "14px" }}>
//                 Plant: {plants.find(p => p.id === plant)?.name || "Unknown"}
//               </p>
//             </div>
//             <button 
//               className="llm-save-btn" 
//               onClick={cancelCreateMode}
//               style={{ background: "#6b7280" }}
//             >
//               Cancel
//             </button>
//           </div>
//         )}

//         {loading && <div className="llm-loading-state">Loading…</div>}
//         {error && <div className="llm-error-state">{error}</div>}
//       </div>

//       {params.length > 0 && (
//         <div className="llm-config-card">
//           <div className="llm-config-section-title">
//             {isCreateMode ? "Create New Model Configuration" : `Edit Model Parameters: ${selectedModelName || model}`}
//             {/* {params.length > 0 && (
//               <div style={{ float: "right", fontSize: "14px", fontWeight: "normal" }}>
//                 <input
//                   type="text"
//                   className="llm-search-box"
//                   placeholder="Search parameters..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   style={{ width: "250px", padding: "6px 12px" }}
//                 />
//               </div>
//             )} */}
//           </div>

//           {filteredParams.length === 0 ? (
//             <div className="llm-no-results">No matching parameters found.</div>
//           ) : (
//             filteredParams.map((field) => {
//               // Skip PlantGUID as it's already set
//               if (field.column_name === "PlantGUID" || field.column_name === "plantguid") {
//                 return null;
//               }
//               return (
//                 <div className="llm-config-item" key={field.column_name}>
//                   <div className="llm-config-label-wrapper">
//                     <div className="llm-config-main-row">
//                       <span className="llm-config-label-text">
//                         {field.column_name.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
//                       </span>
//                       <span className="llm-info-tooltip">
//                         <span className="llm-info-icon">ⓘ</span>
//                         <span className="llm-tooltip-text">
//                           {field.data_type} {field.is_nullable === "YES" ? "(nullable)" : "(required)"}
//                         </span>
//                       </span>
//                     </div>
//                   </div>
//                   <div>{renderControl(field)}</div>
//                 </div>
//               );
//             })
//           )}

//           <div style={{ padding: "20px 24px", borderTop: "1px solid #e5e7eb", display: "flex", justifyContent: "flex-end", gap: "12px" }}>
//             {model && !isCreateMode && (
//               <button 
//                 className="btn btn-negative" 
//                 onClick={handleDelete}
//                 disabled={deleting}
//                 style={{ background: "#ef4444" }}
//               >
//                 {deleting ? "Deleting..." : "Delete"}
//               </button>
//             )}
            
//             <button 
//               className="btn" 
//               onClick={handleSave}
//               disabled={saving || !plant}
//             >
//               {saving ? "Saving…" : isCreateMode ? "Create Configuration" : "Save Changes"}
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };



import React, { useEffect, useState } from "react";
import "./LLM_Configuration.css";
import axios from "axios";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Backdrop,
} from "@mui/material";

import { Close as CloseIcon } from "@mui/icons-material";

// Confirm Dialog Component
const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #E7E8E9",
          padding: "10px 24px",
        }}
      >
        <Typography variant="h6">Confirmation</Typography>
        <IconButton edge="end" color="inherit" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ textAlign: "center", py: 3 }}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 500,
              color: "#374151",
              mb: 2,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#6b7280",
              lineHeight: 1.5,
            }}
          >
            {message}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "1rem",
          borderTop: "1px solid #E7E8E9",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <button className="btn btn-negative" onClick={onClose}>
          {cancelText}
        </button>
        <button className="btn" onClick={onConfirm}>
          {confirmText}
        </button>
      </DialogActions>
    </Dialog>
  );
};

// Success Dialog Component
const SuccessDialog = ({
  open,
  onClose,
  title = "Operation Completed Successfully!",
}) => {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [open, onClose]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          width: "360px",
          maxWidth: "360px",
          borderRadius: "10px",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #E7E8E9",
          padding: "8px 12px",
          minHeight: "48px",
        }}
      >
        <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>Success</Typography>
        <IconButton size="small" onClick={onClose} sx={{ padding: "4px" }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "24px !important" }}>
        <div style={{ textAlign: "center" }}>
          <img
            src="/images/succesfull-check.png"
            alt="Success"
            style={{ width: 48, height: 48, marginBottom: 12 }}
          />
          <Typography
            sx={{
              fontSize: "15px",
              color: "#374151",
              fontWeight: 500,
              lineHeight: 1.5,
            }}
          >
            {title}
          </Typography>
        </div>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "12px",
          borderTop: "1px solid #E7E8E9",
          justifyContent: "center",
        }}
      >
        <button
          className="btn"
          style={{ minWidth: "80px" }}
          onClick={onClose}
        >
          OK
        </button>
      </DialogActions>
    </Dialog>
  );
};

// Error Dialog Component
const ErrorDialog = ({ open, onClose, title = "An error occurred" }) => {
  if (!open) return null;

  return (
    <>
      <Backdrop
        open={open}
        sx={{
          zIndex: 1999,
          backgroundColor: "rgba(0,0,0,0.18)",
          backdropFilter: "blur(2px)",
        }}
      />
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
          border: "1px solid #e5e7eb",
          padding: "24px",
          textAlign: "center",
          zIndex: 2000,
          width: "340px",
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        <Box sx={{ fontSize: 32, mb: 2 }}>⚠️</Box>
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 500,
            color: "#374151",
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          {title}
        </Typography>
        <button
          className="btn"
          onClick={onClose}
          style={{ background: "#1d4ed8", color: "#fff", width: "100%" }}
        >
          Close
        </button>
      </Box>
    </>
  );
};

export const LLM_Configuration = () => {
  const [plants, setPlants] = useState([]);
  const [models, setModels] = useState([]);
  const [params, setParams] = useState([]);
  const [plant, setPlant] = useState("");
  const [model, setModel] = useState("");
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [selectedModelName, setSelectedModelName] = useState("");

  // Dialog states
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmConfig, setConfirmConfig] = useState({});
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorDialogMessage, setErrorDialogMessage] = useState("");

  // Column name mappings (frontend name -> database name)
  const COLUMN_MAPPING = {
    "modelname": "ModelName",
    "modelparametersjson": "ModelParametersJson",
    "modelparameters": "ModelParameters",
    "plantguid": "PlantGUID",
    "isactive": "IsActive",
  };

  // Fetch plants
  useEffect(() => {
    axios.get("/config/llm-plants/", { withCredentials: true })
      .then((response) => {
        const data = response.data;
        if (data.success) {
          setPlants(data.data || []);
        } else {
          setError("Failed to load plants");
        }
      })
      .catch(() => setError("Failed to load plants"));
  }, []);

  const showConfirm = (config) => {
    setConfirmConfig(config);
    setConfirmOpen(true);
  };

  const showSuccess = (message) => {
    setSuccessMessage(message);
    setSuccessOpen(true);
  };

  const showError = (message) => {
    setErrorDialogMessage(message);
    setErrorDialogOpen(true);
  };

  const selectPlant = (plantId) => {
    setPlant(plantId);
    setModel("");
    setSelectedModelName("");
    setParams([]);
    setFormData({});
    setIsCreateMode(false);
    setError("");
    setSearchTerm("");

    if (!plantId) return;

    setLoading(true);
    axios.get(`/config/llm-models/${plantId}/`, { withCredentials: true })
      .then((response) => {
        const data = response.data;
        if (data.success) {
          setModels(data.data || []);
        } else {
          setError("Failed to load models");
        }
      })
      .catch(() => setError("Failed to load models"))
      .finally(() => setLoading(false));
  };

  const selectModel = (modelId) => {
    setModel(modelId);
    setIsCreateMode(false);
    setError("");
    setSearchTerm("");

    if (!modelId) {
      setParams([]);
      setFormData({});
      setSelectedModelName("");
      return;
    }

    const selectedModel = models.find(m => m.id === modelId);
    setSelectedModelName(selectedModel ? selectedModel.name : "");

    setLoading(true);
    axios.get(`/config/llm-configurations/${modelId}/`, { withCredentials: true })
      .then((response) => {
        const data = response.data;
        if (data.success) {
          const fields = data.data || [];
          setParams(fields);
          const values = {};
          fields.forEach((f) => {
            const val = f.value;
            if (f.data_type === "jsonb" && typeof val === "object" && val !== null) {
              values[f.column_name] = JSON.stringify(val, null, 2);
            } else {
              values[f.column_name] = val ?? "";
            }
          });
          setFormData(values);
        } else {
          setError("Failed to load parameters");
        }
      })
      .catch(() => setError("Failed to load parameters"))
      .finally(() => setLoading(false));
  };

  const startCreateMode = () => {
    if (!plant) {
      setError("Please select a plant first");
      return;
    }
    
    setModel("");
    setSelectedModelName("");
    setIsCreateMode(true);
    setError("");
    setSearchTerm("");

    setLoading(true);
    axios.get("/config/llm-configurations/", { withCredentials: true })
      .then((response) => {
        const data = response.data;
        if (data.success) {
          const fields = data.data || [];
          setParams(fields);
          const values = {};
          fields.forEach((f) => {
            values[f.column_name] = "";
          });
          if (plant) {
            values.PlantGUID = plant;
          }
          setFormData(values);
        } else {
          setError("Failed to load form");
        }
      })
      .catch(() => setError("Failed to load form"))
      .finally(() => setLoading(false));
  };

  const cancelCreateMode = () => {
    setIsCreateMode(false);
    setModel("");
    setSelectedModelName("");
    setParams([]);
    setFormData({});
    setError("");
    setSearchTerm("");
    if (plant) {
      selectPlant(plant);
    }
  };

  const changeValue = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const renderControl = (field) => {
    const value = formData[field.column_name] ?? "";
    const name = field.column_name;

    if (name === "isactive" || name === "IsActive") {
      return (
        <label className="llm-toggle-switch">
          <input
            type="checkbox"
            checked={value === true || value === "true" || value === 1}
            onChange={(e) => changeValue(name, e.target.checked)}
          />
          <span className="llm-slider"></span>
        </label>
      );
    }
    if (field.data_type === "jsonb") {
      return (
        <textarea
          className="llm-input-field"
          rows={4}
          value={value}
          onChange={(e) => {
            const val = e.target.value;
            try {
              if (val.trim()) JSON.parse(val);
              changeValue(name, val);
            } catch {
              changeValue(name, val);
            }
          }}
          style={{
            borderColor: (() => {
              try {
                if (value.trim()) JSON.parse(value);
                return undefined;
              } catch {
                return "#ef4444";
              }
            })()
          }}
        />
      );
    }
    if (field.data_type === "integer" || field.data_type === "bigint") {
      return (
        <input
          type="number"
          className="llm-input-field"
          value={value}
          onChange={(e) => changeValue(name, e.target.value)}
        />
      );
    }
    if (field.data_type === "boolean") {
      return (
        <label className="llm-toggle-switch">
          <input
            type="checkbox"
            checked={value === true || value === "true" || value === 1}
            onChange={(e) => changeValue(name, e.target.checked)}
          />
          <span className="llm-slider"></span>
        </label>
      );
    }
    return (
      <input
        type="text"
        className="llm-input-field"
        value={value}
        onChange={(e) => changeValue(name, e.target.value)}
      />
    );
  };

  const filteredParams = params.filter((field) => {
    const label = field.column_name.replace(/_/g, " ").toLowerCase();
    return label.includes(searchTerm.toLowerCase()) || 
           field.column_name.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const prepareSubmitData = () => {
    const submitData = {};
    Object.keys(formData).forEach(key => {
      let dbKey = COLUMN_MAPPING[key] || key;
      let val = formData[key];
      
      const field = params.find(f => f.column_name === key);
      if (field && field.data_type === "jsonb" && typeof val === "string" && val.trim()) {
        try {
          submitData[dbKey] = JSON.parse(val);
        } catch {
          submitData[dbKey] = val;
        }
      } else {
        submitData[dbKey] = val === "" ? null : val;
      }
    });

    submitData.PlantGUID = plant;
    return submitData;
  };

  const handleSaveClick = () => {
    if (!plant) {
      showError("Please select a plant");
      return;
    }
    
    const modelNameValue = formData.modelname || formData.ModelName;
    if (isCreateMode && !modelNameValue) {
      showError("ModelName is required");
      return;
    }

    showConfirm({
      title: isCreateMode ? "Create New Model" : "Save Changes",
      message: isCreateMode 
        ? "Are you sure you want to create this new model configuration?" 
        : "Are you sure you want to save these configuration changes?",
      action: "save"
    });
  };

  const executeSave = () => {
    setSaving(true);
    setError("");

    const url = isCreateMode 
      ? "/config/llm-configurations/" 
      : `/config/llm-configurations/${model}/`;
    
    const method = isCreateMode ? "POST" : "PATCH";
    const submitData = prepareSubmitData();

    axios({
      url,
      method,
      data: submitData,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        const data = response.data;
        if (data.success) {
          const successMsg = isCreateMode 
            ? "Model configuration created successfully" 
            : "Configuration updated successfully";
          
          showSuccess(successMsg);

          if (isCreateMode && data.id) {
            setIsCreateMode(false);
            setModel(data.id);
            selectPlant(plant);
            setTimeout(() => selectModel(data.id), 150);
          } else {
            selectModel(model);
          }
        } else {
          showError(data.message || "Save failed");
        }
      })
      .catch((err) => {
        console.error("Save error:", err);
        showError("Network error: " + err.message);
      })
      .finally(() => setSaving(false));
  };

  const handleDeleteClick = () => {
    if (!model || isCreateMode) return;
    showConfirm({
      title: "Delete Model Configuration",
      message: "Are you sure you want to delete this model configuration? This action cannot be undone.",
      action: "delete"
    });
  };

  const executeDelete = () => {
    setDeleting(true);
    axios.delete(`/config/llm-configurations/${model}/`, { withCredentials: true })
      .then((response) => {
        const data = response.data;
        if (data.success) {
          showSuccess("Model configuration deleted successfully");
          selectPlant(plant);
        } else {
          showError(data.message || "Delete failed");
        }
      })
      .catch(() => showError("Network error during deletion"))
      .finally(() => setDeleting(false));
  };

  const handleConfirm = () => {
    setConfirmOpen(false);
    if (confirmConfig.action === "save") {
      executeSave();
    } else if (confirmConfig.action === "delete") {
      executeDelete();
    }
  };

  return (
    <div className="llm-admin-container">
      <div className="llm-admin-header">
        <div>
          <h1 className="llm-admin-title">LLM Configuration</h1>
          <p className="llm-admin-subtitle">Manage LLM model configurations per plant</p>
        </div>
        <button 
          className="btn" 
          onClick={startCreateMode}
          disabled={!plant || isCreateMode}
          style={{ background: "#10b981" }}
        >
          + New Model
        </button>
      </div>

      <div className="llm-config-card" style={{ padding: "24px" }}>
        {!isCreateMode ? (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", alignItems: "end" }}>
            <div>
              <label style={{ fontWeight: 600, display: "block", marginBottom: "6px" }}>Select Plant</label>
              <select 
                className="llm-select-field" 
                value={plant} 
                onChange={(e) => selectPlant(e.target.value)}
              >
                <option value="">Select Plant</option>
                {plants.map((p) => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ fontWeight: 600, display: "block", marginBottom: "6px" }}>Select Model</label>
              <select 
                className="llm-select-field" 
                value={model} 
                onChange={(e) => selectModel(e.target.value)}
                disabled={!plant}
              >
                <option value="">Select Model</option>
                {models.map((m) => (
                  <option key={m.id} value={m.id}>{m.name}</option>
                ))}
              </select>
            </div>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <h3 style={{ margin: 0, color: "#1f2937" }}>Create New Model Configuration</h3>
              <p style={{ margin: "4px 0 0 0", color: "#6b7280", fontSize: "14px" }}>
                Plant: {plants.find(p => p.id === plant)?.name || "Unknown"}
              </p>
            </div>
            <button 
              className="llm-save-btn" 
              onClick={cancelCreateMode}
              style={{ background: "#6b7280" }}
            >
              Cancel
            </button>
          </div>
        )}

        {loading && <div className="llm-loading-state">Loading…</div>}
        {error && <div className="llm-error-state">{error}</div>}
      </div>

      {params.length > 0 && (
        <div className="llm-config-card">
          <div className="llm-config-section-title">
            {isCreateMode ? "Create New Model Configuration" : `Edit Model Parameters: ${selectedModelName || model}`}
          </div>

          {filteredParams.length === 0 ? (
            <div className="llm-no-results">No matching parameters found.</div>
          ) : (
            filteredParams.map((field) => {
              if (field.column_name === "PlantGUID" || field.column_name === "plantguid") {
                return null;
              }
              return (
                <div className="llm-config-item" key={field.column_name}>
                  <div className="llm-config-label-wrapper">
                    <div className="llm-config-main-row">
                      <span className="llm-config-label-text">
                        {field.column_name.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
                      </span>
                      <span className="llm-info-tooltip">
                        <span className="llm-info-icon">ⓘ</span>
                        <span className="llm-tooltip-text">
                          {field.data_type} {field.is_nullable === "YES" ? "(nullable)" : "(required)"}
                        </span>
                      </span>
                    </div>
                  </div>
                  <div>{renderControl(field)}</div>
                </div>
              );
            })
          )}

          <div style={{ padding: "20px 24px", borderTop: "1px solid #e5e7eb", display: "flex", justifyContent: "flex-end", gap: "12px" }}>
            {model && !isCreateMode && (
              <button 
                className="btn btn-negative" 
                onClick={handleDeleteClick}
                disabled={deleting}
                style={{ background: "#ef4444" }}
              >
                {deleting ? "Deleting..." : "Delete"}
              </button>
            )}
            
            <button 
              className="btn" 
              onClick={handleSaveClick}
              disabled={saving || !plant}
            >
              {saving ? "Saving…" : isCreateMode ? "Create Configuration" : "Save Changes"}
            </button>
          </div>
        </div>
      )}

      {/* Dialogs */}
      <ConfirmDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
        title={confirmConfig.title}
        message={confirmConfig.message}
      />

      <SuccessDialog
        open={successOpen}
        onClose={() => setSuccessOpen(false)}
        title={successMessage}
      />

      <ErrorDialog
        open={errorDialogOpen}
        onClose={() => setErrorDialogOpen(false)}
        title={errorDialogMessage}
      />
    </div>
  );
};
